

export const newquery = (data) => {
    return {
        type: 'NEW_QUERY',
        data
    }
};






// WEBPACK FOOTER //
// ./src/services/actions/index.js